import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import FeatureBadgeRow, { TFeatureBadge } from "../feature-badge-row";
import {
  FEATURE_SET_TAG_WIDTH_LARGE,
  FEATURE_SET_TAG_WIDTH_MEDIUM,
  FEATURE_SET_TAG_WIDTH_SMALL
} from "../feature-badge-row/feature-tag-constants";

const ActiveFeatureSets = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const {
    isPaidAlkhattabat,
    isSubscribedAlkhattabat,
    isPaidVIP,
    isSubscribedVIP,
    isPaidPlus,
    isSubscribedPlus,
    isPaidBoost,
    isSubscribedBoost,
    isPaidRewind,
    isSubscribedRewind,
    isPaidSilver,
    isSubscribedSilver,
    isPaidGold,
    isSubscribedGold,
    isPaidBlack,
    isSubscribedBlack,
    isPaidPlatinum,
    isSubscribedPlatinum,
    isPaidPower,
    isSubscribedPower
  } = advancedStore.getUserSubscriptionStatus.get();

  const badges: TFeatureBadge[] = [
    {
      tag: i18n.get("SILVER_TAG"),
      tagColor: isSubscribedSilver ? colors.all.plumBrown : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_SMALL,
      isActive: isPaidSilver
    },
    {
      tag: i18n.get("GOLD_TAG"),
      tagColor: isSubscribedGold ? colors.all.bronzedGold : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_SMALL,
      isActive: isPaidGold
    },
    {
      tag: i18n.get("PLATINUM_TAG"),
      tagColor: isSubscribedPlatinum
        ? colors.all.mutedSteelBlue
        : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_LARGE,
      isActive: isPaidPlatinum
    },
    {
      tag: i18n.get("BLACK_TAG"),
      tagColor: isSubscribedBlack ? colors.all.black : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_SMALL,
      isActive: isPaidBlack
    },
    {
      tag: i18n.get("VIP"),
      tagColor: isSubscribedVIP ? colors.all.vipGold : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_SMALL,
      isActive: isPaidVIP
    },
    {
      tag: i18n.get("PLUS"),
      tagColor: isSubscribedPlus ? colors.all.purple : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive: isPaidPlus
    },
    {
      tag: i18n.get("KHATTABAT_TAG"),
      tagColor: isSubscribedAlkhattabat
        ? colors.all.brightCyan
        : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_LARGE,
      isActive: isPaidAlkhattabat
    },
    {
      tag: i18n.get("BOOST"),
      tagColor: isSubscribedBoost ? colors.all.vipGold : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive: isPaidBoost
    },
    {
      tag: i18n.get("REWIND"),
      tagColor: isSubscribedRewind ? colors.all.purple : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive: isPaidRewind
    },
    {
      tag: i18n.get("BUNDLE"),
      tagColor: isSubscribedPower ? colors.all.powerPurple : colors.all.gray,
      tagWidth: FEATURE_SET_TAG_WIDTH_MEDIUM,
      isActive: isPaidPower
    }
  ];

  return <FeatureBadgeRow labelKey={"ACTIVE_FEATURE_SETS"} badges={badges} />;
});

export default ActiveFeatureSets;
